import React from "react";
import { Link } from "react-router-dom";

const PortfolioSidebar = () => {
  return (
    <div className="sidebar__wrapper">
      <div className="sidebar__widget mb-40">
        <h3 className="sidebar__widget-title">Search Here</h3>
        <div className="sidebar__widget-content">
          <div className="sidebar__search">
            <form onSubmit={e => e.preventDefault()}>
              <div className="sidebar__search-input-2">
                <input type="text" placeholder="Search" />
                <button type="submit">
                  <i className="far fa-search"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="sidebar__widget mb-40">
        <h3 className="sidebar__widget-title">Categories</h3>
        <div className="sidebar__widget-content">
          <ul>
            <li>
              <Link to="/Portfolio">Web Design</Link> <span>03</span>
            </li>
            <li>
              <Link to="/Portfolio">Branding Design</Link> <span>07</span>
            </li>
            <li>
              <Link to="/Portfolio">Photography </Link> <span>09</span>
            </li>
            <li>
              <Link to="/Portfolio">
                Business Statergy <span>01</span>
              </Link>
            </li>
            <li>
              <Link to="/Portfolio">UI/UX Design </Link> <span>00</span>
            </li>
            <li>
              <Link to="/Portfolio">Web Development</Link> <span>26</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="sidebar__widget mb-40">
        <h3 className="sidebar__widget-title">pages</h3>
        <div className="sidebar__widget-content wd-hide-border">
          <ul>
            <li>
              <Link to="/Portfolio">Web Design</Link>
            </li>
            <li>
              <Link to="/Portfolio">Branding Design </Link>
            </li>
            <li>
              <Link to="/Portfolio">Photography </Link>
            </li>
            <li>
              <Link to="/Portfolio">Business Statergy</Link>
            </li>
            <li>
              <Link to="/Portfolio">UI/UX Design</Link>
            </li>
            <li>
              <Link to="/Portfolio">Web Development</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="sidebar__widget mb-40">
        <h3 className="sidebar__widget-title">Recent Post</h3>
        <div className="sidebar__widget-content">
          <div className="sidebar__post rc__post">
            <div className="rc__post mb-20 d-flex align-items-center">
              <div className="rc__post-thumb mr-20">
                <Link to="/Portfolio-details">
                  <img src="assets/img/Portfolio/sidebar/Portfolio-sm-1.jpg" alt="" />
                </Link>
              </div>
              <div className="rc__post-content">
                <div className="rc__meta">
                  <span>4 March. 2022</span>
                </div>
                <h3 className="rc__post-title">
                  <Link to="/Portfolio-details">
                    Don’t Underestimate The Software Administration UX
                  </Link>
                </h3>
              </div>
            </div>
            <div className="rc__post mb-20 d-flex align-items-center">
              <div className="rc__post-thumb mr-20">
                <Link to="/Portfolio-details">
                  <img src="assets/img/Portfolio/sidebar/Portfolio-sm-2.jpg" alt="" />
                </Link>
              </div>
              <div className="rc__post-content">
                <div className="rc__meta">
                  <span>4 March. 2022</span>
                </div>
                <h3 className="rc__post-title">
                  <Link to="/Portfolio-details">
                    Designing Human-Machine Interfaces..
                  </Link>
                </h3>
              </div>
            </div>
            <div className="rc__post mb-20 d-flex align-items-center">
              <div className="rc__post-thumb mr-20">
                <Link to="/Portfolio-details">
                  <img src="assets/img/Portfolio/sidebar/Portfolio-sm-3.jpg" alt="" />
                </Link>
              </div>
              <div className="rc__post-content">
                <div className="rc__meta">
                  <span>4 March. 2022</span>
                </div>
                <h3 className="rc__post-title">
                  <Link to="/Portfolio-details">
                    Web Design Done Well: Excellent Editorial
                  </Link>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default PortfolioSidebar;
